import { createSelector } from 'reselect'

import { selectActualFeatureFlags } from 'containers/App/selectors'
import { CAMPAIGN_TYPES_VALUES, DELIVERY } from 'containers/AwarenessCenter/constants'

import { CAMPAIGN_RESULT_STATUSES, TRAINING_STATUS_OPTIONS } from './constants'

const selectData = (state) => state.awarenessCenter.campaignReport.data
const selectLoader = (state) => state.awarenessCenter.campaignReport.loader
const selectTableLoader = (state) => state.awarenessCenter.campaignReport.tableLoader
const selectDuplicateCampaignLoader = (state) =>
  state.awarenessCenter.campaignReport.duplicateCampaignLoader
const selectError = (state) => state.awarenessCenter.campaignReport.error
const selectSegment = (state) => state.awarenessCenter.campaignReport.segment
const selectEmailPreviewLoader = (state) => state.awarenessCenter.campaignReport.emailPreviewLoader
const selectEmailPreviewError = (state) => state.awarenessCenter.campaignReport.emailPreviewError
const selectEmailPreview = (state) => state.awarenessCenter.campaignReport.emailPreview
const selectFilters = (state) => state.awarenessCenter.campaignReport.filters
const selectEmailDetails = (state) => state.awarenessCenter.campaignReport.emailDetails
const selectSummaryData = (state) => state.awarenessCenter.campaignReport.summaryData
const selectCreatedCampaignId = (state) => state.awarenessCenter.campaignReport.createdCampaignId
const selectReportParticipantsData = (state) =>
  state.awarenessCenter.campaignReport.reportParticipantsData
const selectTrainingResultsModalStatus = (state) =>
  state.awarenessCenter.campaignReport.trainingResultsModalStatus
const selectTrainingResultsPostponedDate = (state) =>
  state.awarenessCenter.campaignReport.trainingResultsPostponedDate
const selectTrainingResultsModalLoader = (state) =>
  state.awarenessCenter.campaignReport.trainingResultsModalLoader

export const selectTemplateOptions = createSelector(
  selectReportParticipantsData,
  (participantsData) =>
    participantsData.meta.scenarios.map((template) => ({
      label: template,
      value: template,
    }))
)

export const selectSimulationResultOptions = createSelector(selectData, (data) => {
  let options = TRAINING_STATUS_OPTIONS.filter(
    (e) =>
      e.value !== CAMPAIGN_RESULT_STATUSES.POSTPONED &&
      e.value !== CAMPAIGN_RESULT_STATUSES.TRAINED &&
      e.value !== CAMPAIGN_RESULT_STATUSES.NOT_TRAINED &&
      e.value !== CAMPAIGN_RESULT_STATUSES.MANUALLY_TRAINED &&
      e.value !== CAMPAIGN_RESULT_STATUSES.NOT_AVAILABLE &&
      e.value !== CAMPAIGN_RESULT_STATUSES.TRAINING_BLANK_LEGACY
  )

  if (data.delivery_type === DELIVERY.SMS) {
    options = TRAINING_STATUS_OPTIONS.filter((e) => e.value !== CAMPAIGN_RESULT_STATUSES.REPORTED)
  }

  return options
})

export const selectTrainingResultOptions = createSelector(
  selectData,
  selectActualFeatureFlags,
  (data, ff) => {
    if (data.flow_type === CAMPAIGN_TYPES_VALUES.TRAINING) {
      return TRAINING_STATUS_OPTIONS.filter(
        (e) =>
          e.value !== CAMPAIGN_RESULT_STATUSES.CLICKED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.REPORTED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.ENTERED_DATA &&
          e.value !== CAMPAIGN_RESULT_STATUSES.NOT_AVAILABLE &&
          e.value !== CAMPAIGN_RESULT_STATUSES.TRAINING_BLANK_LEGACY
      )
    }

    if (data.flow_type === CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING) {
      return TRAINING_STATUS_OPTIONS.filter(
        (e) =>
          e.value !== CAMPAIGN_RESULT_STATUSES.CLICKED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.REPORTED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.ENTERED_DATA &&
          e.value !== CAMPAIGN_RESULT_STATUSES.OPENED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.UNOPENED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.NOT_DELIVERED &&
          e.value !== CAMPAIGN_RESULT_STATUSES.TRAINING_BLANK_LEGACY
      )
    }

    let options = TRAINING_STATUS_OPTIONS.filter(
      (e) =>
        e.value !== CAMPAIGN_RESULT_STATUSES.CLICKED &&
        e.value !== CAMPAIGN_RESULT_STATUSES.REPORTED &&
        e.value !== CAMPAIGN_RESULT_STATUSES.ENTERED_DATA &&
        e.value !== CAMPAIGN_RESULT_STATUSES.OPENED &&
        e.value !== CAMPAIGN_RESULT_STATUSES.UNOPENED &&
        e.value !== CAMPAIGN_RESULT_STATUSES.NOT_DELIVERED
    )

    if (!ff.CUSTOM_PARTICIPANT_FILTERS_LEGACY) {
      options = options.filter((e) => e.value !== CAMPAIGN_RESULT_STATUSES.TRAINING_BLANK_LEGACY)
    }

    return options
  }
)

const selectDepartmentsOptions = createSelector(selectReportParticipantsData, (data) =>
  data.meta.departments.map((department) => ({
    label: department,
    value: department,
  }))
)

const selectSelectionData = (state) => state.awarenessCenter.campaignReport.selectionData

export {
  selectData,
  selectLoader,
  selectTableLoader,
  selectDuplicateCampaignLoader,
  selectError,
  selectSegment,
  selectEmailPreviewLoader,
  selectEmailPreviewError,
  selectEmailPreview,
  selectReportParticipantsData,
  selectFilters,
  selectDepartmentsOptions,
  selectEmailDetails,
  selectSummaryData,
  selectCreatedCampaignId,
  selectSelectionData,
  selectTrainingResultsModalStatus,
  selectTrainingResultsPostponedDate,
  selectTrainingResultsModalLoader,
}
